<script module lang="ts">
  // The design's black nav pill, white under a `dark` ancestor. Exported for
  // the signed-out pill beside this component in the marketing header.
  export const PILL_CLASS =
    "bg-ink dark:text-ink rounded-full px-4 py-2 text-[13px] font-semibold text-white transition-opacity hover:opacity-90 max-[390px]:px-3 dark:bg-white"
</script>

<script lang="ts">
  import { Link, page } from "@inertiajs/svelte"
  import { _ } from "svelte-i18n"

  import { landingReferral } from "@/lib/landing_referral.svelte"
  import { goPath } from "@/routes"
  import { getInitials } from "@/runes/use-initials"
  import type { Auth } from "@/types"

  // Arriving from a site's "Made with TOBY" badge as one of its members, the
  // pill opens that site's editor on the page they came from instead of /go.
  const shortcut = $derived(landingReferral.shortcut)

  // The avatar menu (identity + log out) needs the full shared `auth` prop,
  // not just a `signed_in` boolean. Marketing controllers inherit
  // InertiaController, so `auth` (user + session) and `site` are shared even
  // on the logged-out chrome whenever a session exists — so UserMenuContent
  // works here exactly as it does in the app header.
  const auth = $derived(page.props.auth as Auth | undefined)

  // The avatar menu is imported on demand (see marketing-user-menu.svelte):
  // its bits-ui menu stack must not ride the marketing page's preloaded
  // chunks, where a throttled phone pays for it before the hero paints. SSR
  // and the moment before the chunk lands show a static look-alike avatar.
  const avatarClass =
    "bg-muted text-muted-foreground inline-flex size-8 shrink-0 items-center justify-center overflow-hidden rounded-full text-xs font-medium"
</script>

<Link
  href={shortcut?.edit_url ?? goPath()}
  title={shortcut?.host}
  class={PILL_CLASS}
>
  {$_("home.go_to_site")}
</Link>
{#if auth?.user}
  {#await import("@/components/marketing-user-menu.svelte")}
    <span class={avatarClass} aria-hidden="true">
      {#if auth.user.avatar}
        <img src={auth.user.avatar} alt="" class="size-full object-cover" />
      {:else}
        {getInitials(auth.user.name)}
      {/if}
    </span>
  {:then { default: UserMenu }}
    <UserMenu {auth} />
  {/await}
{/if}
